import { Text, Heading, Img } from "./..";

export default function PricingPlanBody({
  corefeaturestitle = "Core features",
  image = "images/img_teenyicons_tick_circle_solid.svg",
  featuredescription1 = "Realtime Data from Vibration and current sensors",
  featuredescription2 = "Alarms and events",
  featuredescription3 = "Metric (OEE) forecasting",
  featuredescription4 = "3-level role-based dashboard access for up to 10 users",
  featuredescription5 = "Dashboard parameters: OEE, TPE, cycle time, Predictive maintenance",
  featuredescription6 = "",
  featuredescription7 = "",
  featuredescription8 = "",
  featuredescription9 = "",
  supporttitle = "Support on:",
  supportoption1 = "Whatsapp",
  supportoption2 = "Phone",
  supportoption3 = "",
  bestfortitle = "Best for",
  bestfordescription = "Small businesses with few machines needing productivity monitoring",
  ...props
}) {
  return (
    <div {...props} className="flex flex-col gap-4 rounded-lg border-[1.5px] border-solid border-gray-300 bg-white px-4 py-6 h-full">
      {/* Core Features */}
      <div className="flex flex-col gap-4 mb-6">
        <Heading size="headingxs" as="p" className="text-[13.59px] font-bold text-indigo-900 md:text-[20px]">
          {corefeaturestitle}
        </Heading>
        <div className="flex flex-col gap-3">
          {[featuredescription1, featuredescription2, featuredescription3, featuredescription4, featuredescription5, 
            featuredescription6, featuredescription7, featuredescription8, featuredescription9,
          ].map(
            (description, index) => description ? (
              <div key={index} className="flex items-start gap-2">
                <Img src={image} alt="Feature Icon" className="h-[12px]" />
                <Text size="textlg" as="p" className="text-[13px] font-normal text-gray-600 md:text-[16px]">
                  {description}
                </Text>
              </div>
            ) : (<br/>)
          )}
        </div>
      </div>

      {/* Support and Best For */}
      <div className="flex flex-col gap-4 mt-auto">
        <div>
          <Heading size="headingxs" as="p" className="text-[13.59px] font-bold text-indigo-900 md:text-[18px]">
            {supporttitle}
          </Heading>
          <Text size="textlg" as="p" className="text-[13.59px] font-normal text-gray-600 md:text-[16px]">
            {supportoption1}
          </Text>
          <Text size="textlg" as="p" className="text-[13.59px] font-normal text-gray-600 md:text-[16px]">
            {supportoption2}
          </Text>
          {supportoption3 ? (
            <Text size="textlg" as="p" className="text-[13.59px] font-normal text-gray-600 md:text-[16px]">
            {supportoption3}
          </Text>
          ) : (<> <br/> <br/> </>) }
        </div>
        <div>
          <Heading size="headingxs" as="p" className="text-[13.59px] font-bold text-indigo-900 md:text-[18px]">
            {bestfortitle}
          </Heading>
          <Text size="textlg" as="p" className="text-[13.59px] font-normal text-gray-600 md:text-[16px]">
            {bestfordescription}
          </Text>
        </div>
      </div>
    </div>
  );
}
